import React, { useState, useEffect } from "react";
import Styles from "./CompanyDetails.module.css";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  fetchFullConsumerDetails,
  fetchFullGeneratorDetails,
  fetchConsumersCompanyId,
  fetchGeneratorsCompanyId,
  fetchCompanyById,
} from "../../../Redux/Slices/gnaAdminSlice";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ConfirmationModal from "../../../commons/ConfirmationModal/ConfirmationModal";
import {
  handleUpdateCompanyStatus_Admin,
  changeConsumerActiveStatusSuperAdmin,
  changeGeneratorActiveStatusSuperAdmin,
  addUserSuperAdmin,
  updateUserSuperAdmin,
  changeUserActiveStatusSuperAdmin,
  apiAssignCompanyTrader,
  sendStatusChangeNotification,
} from "../../../Services/GNA/AlterApi";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../commons/Toast/ErrorMessage";
import { toast } from "react-toastify";
import CompanyAdminConsumerForm from "../../CompanyAdmin/CompanyAdminConsumerForm/CompanyAdminConsumerForm";
import CompanyAdminGeneratorForm from "../../CompanyAdmin/CompanyAdminGeneratorForm/CompanyAdminGeneratorForm";
import AddUserModal from "../../Modals/CompanyAdmin/AddUserModal/AddUserModal";
import ActionModal from "../../Modals/CompanyAdmin/ActionModal/ActionModal";
import ReasonModal from "../../../commons/ReasonModal/ReasonModal";
import NotifyEmailModal from "../../../commons/NotifyEmailModal/NotifyEmailModal";
import { Modal } from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { usePdfPreview } from "../../../hooks/usePdfPreview";
import SelectInput from "../../../commons/Inputs/Select/SelectInput";
import CompanyMainDetails from "./CompanyMainDetails";
import ConsumerDetails from "./ConsumerDetails";
import GeneratorDetails from "./GeneratorDetails";
import DiscomDetails from "./DiscomDetails";
import DocumentDetails from "./DocumentDetails";
import ConfigurationDetails from "./ConfigurationDetails";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getCompanyEntityData } from "../SuperAdmin/superAdminHelper";

const company = { name: "Company Information", value: "Company" };
const consumer = { name: "Consumer Details", value: "Consumer" };
const generator = { name: "Generator Details", value: "Generator" };
const discom = { name: "Discom Details", value: "Discom" };
const documents = { name: "Documents", value: "Documents" };
const config = { name: "Configuration", value: "Configuration" };

// const discomList = [company, consumer, generator, discom, documents, config];
// const prosumerList = [company, consumer, generator, documents, config];
// const consumerList = [company, consumer, documents, config];
// const generatorList = [company, generator, documents, config];
// const traderList = [company, generator, consumer, discom, documents, config];
const discomList = [company, consumer, generator, discom, documents];
const prosumerList = [company, consumer, generator, documents];
const consumerList = [company, consumer, documents];
const generatorList = [company, generator, documents];
const traderList = [company, generator, consumer, discom, documents];

const headerDataMap = {
  Discom: discomList,
  Prosumer: prosumerList,
  Consumer: consumerList,
  Generator: generatorList,
  Trader: traderList,
};

const headerLists = (type) => {
  return headerDataMap[type] || [];
};

const CompanyDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const companyId = location?.search?.split("=")[1];

  const company = useSelector(
    (state) => state?.gnaAdminSlice?.fetchCompanyById?.data,
  );

  const consumers = useSelector(
    (state) => state?.gnaAdminSlice?.fetchConsumersCompanyId?.data,
  );
  const generators = useSelector(
    (state) => state?.gnaAdminSlice?.fetchGeneratorsCompanyId?.data,
  );

  const discoms = useSelector(
    (state) => state?.gnaAdminSlice?.fetchDiscomssCompanyId?.data,
  );
  const fullConsumerDetails = useSelector(
    (state) => state?.gnaAdminSlice?.fetchFullConsumerDetails?.data,
  );
  const fullGeneratorDetails = useSelector(
    (state) => state?.gnaAdminSlice?.fetchFullGeneratorDetails?.data,
  );

  const traders = useSelector(
    (state) => state?.gnaAdminSlice?.fetchFullTrader?.data,
  );
  const role = useSelector((state) => state?.persistedReducer?.userType);

  const [activeView, setActiveView] = useState("Company");

  useEffect(() => {
    const initialStatus = {};
    consumers?.forEach((consumer) => {
      initialStatus[consumer.consumerId] =
        consumer.isActive ?? consumer.status ?? true;
    });
    generators?.forEach((generator) => {
      initialStatus[generator.generatorId] =
        generator.isActive ?? generator.status ?? true;
    });
    setEntityStatus(initialStatus);
  }, [consumers, generators]);

  useEffect(() => {
    if (activeView === "Consumer" && consumers?.length > 0) {
      const firstId = consumers[0]?.consumerId;
      setActiveEntity(firstId);
      dispatch(fetchFullConsumerDetails(firstId));
    } else if (activeView === "Generator" && generators?.length > 0) {
      const firstId = generators[0]?.generatorId;
      setActiveEntity(firstId);
      dispatch(fetchFullGeneratorDetails(firstId));
    } else {
      setActiveEntity("");
    }
  }, [activeView]); // eslint-disable-line react-hooks/exhaustive-deps

  const [activeEntity, setActiveEntity] = useState(
    activeView === "Consumer"
      ? consumers?.[0]?.consumerId
      : activeView === "Generator"
        ? generators?.[0]?.generatorId
        : "",
  );

  const [confirmModal, setConfirmModal] = useState({
    status: false,
    heading: "",
    text: "",
    type: "",
  });

  const [reasonModal, setReasonModal] = useState({
    open: false,
    actionType: "",
    type: "",
  });

  const [openGen, setOpenGen] = useState(false);
  const [openCon, setOpenCon] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const [entityStatus, setEntityStatus] = useState({});
  const [toggleConfirmModal, setToggleConfirmModal] = useState({
    status: false,
    heading: "",
    text: "",
    entityType: "",
    entityId: null,
  });

  // User management state
  const [openUserModal, setOpenUserModal] = useState(false);
  const [userModalType, setUserModalType] = useState("add"); // "add" or "edit"
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedEntityForUser, setSelectedEntityForUser] = useState(null);
  const [userConfirmModal, setUserConfirmModal] = useState({
    status: false,
    heading: "",
    text: "",
    userId: null,
    action: "", // "toggle" or "delete"
  });

  // ActionModal state
  const [openAction, setOpenAction] = useState(false);
  const [selectedEntityForAction, setSelectedEntityForAction] = useState(null);

  // Notify email modal state
  const [notifyEmailOpen, setNotifyEmailOpen] = useState(false);
  const [notifyEmailLoading, setNotifyEmailLoading] = useState(false);

  const userAction = !(role === "MAKER" || role === "CHECKER");

  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  let headerList = headerLists(
    company?.roles?.includes("TRADER")
      ? "Trader"
      : company?.roles?.includes("BANKING")
        ? "Discom"
        : company?.roles?.includes("GENERATOR") &&
            company?.roles?.includes("CONSUMER")
          ? "Prosumer"
          : company?.roles?.includes("CONSUMER")
            ? "Consumer"
            : company?.roles?.includes("GENERATOR")
              ? "Generator"
              : "N/A",
  );

  const filteredHeaderList = headerList.filter(
    (item) => userAction || item.value !== "Configuration",
  );

  const handleEntity = (id, entityType = "Consumer") => {
    if (activeEntity === id) {
      setActiveEntity("");
    } else {
      setActiveEntity(id);
      if (entityType === "Consumer") {
        dispatch(fetchFullConsumerDetails(id));
      } else if (entityType === "Generator") {
        dispatch(fetchFullGeneratorDetails(id));
      }
    }
  };

  const handleUpdateStatus = async (formData) => {
    const status = reasonModal.type || confirmModal?.type;

    let res = await handleUpdateCompanyStatus_Admin({
      companyId: companyId,
      status,
      ...(typeof formData === "object"
        ? {
            reasons: formData.reasons || [],
            reviewedBy: formData.reviewedBy,
            actionDate: formData.date,
            notify: formData.notify,
            emailSubject: formData.emailSubject,
            emailMessage: formData.emailMessage,
            notes: formData.notes,
          }
        : {}),
    });

    if (res?.data?.code === 200) {
      if (
        typeof formData === "object" &&
        formData.notify === "email" &&
        ["HOLD", "REJECTED", "UN_VERIFIED"].includes(status)
      ) {
        const [yyyy, mm, dd] = (formData.date || "").split("-");
        const actionDate =
          dd && mm && yyyy ? `${dd}-${mm}-${yyyy}` : formData.date;
        await sendStatusChangeNotification({
          companyId: Number(companyId),
          consumerId: null,
          generatorId: null,
          subject: formData.emailSubject,
          message: formData.emailMessage,
          actionDate,
          reviewerName: formData.reviewedBy || "",
          reasons: formData.reasons || [],
          note: formData.notes || "",
          ccEmails: [],
        });
      }
      window.location.reload();
      setReasonModal({ open: false, actionType: "", type: "" });
      setConfirmModal({ status: false, heading: "", text: "", type: "" });
    } else {
      ErrorMessage(res?.data?.error);
    }
  };

  const handleToggleEntity = (entityId, entityType) => {
    const currentStatus = entityStatus[entityId];
    const entityName =
      entityType === "Consumer"
        ? consumers?.find((c) => c.consumerId === entityId)?.consumerName
        : generators?.find((g) => g.generatorId === entityId)?.generatorName;

    setToggleConfirmModal({
      status: true,
      heading: currentStatus ? "Deactivate" : "Activate",
      text: `Do you want to ${
        currentStatus ? "deactivate" : "activate"
      } ${entityName}?`,
      entityType,
      entityId,
    });
  };

  const handleConfirmToggle = async () => {
    const { entityId, entityType } = toggleConfirmModal;
    const currentStatus = entityStatus[entityId];
    const newStatus = !currentStatus;

    try {
      const userName = "superadmin";

      if (entityType === "Consumer") {
        await changeConsumerActiveStatusSuperAdmin(
          entityId,
          newStatus,
          userName,
        );
      } else if (entityType === "Generator") {
        await changeGeneratorActiveStatusSuperAdmin(
          entityId,
          newStatus,
          userName,
        );
      }

      setEntityStatus((prev) => ({
        ...prev,
        [entityId]: newStatus,
      }));

      if (companyId) {
        dispatch(fetchConsumersCompanyId(companyId));
        dispatch(fetchGeneratorsCompanyId(companyId));
      }

      toast.success(
        `${entityType} ${newStatus ? "activated" : "deactivated"} successfully!`,
      );

      setToggleConfirmModal({
        status: false,
        heading: "",
        text: "",
        entityType: "",
        entityId: null,
      });
    } catch (error) {
      toast.error(
        `Failed to update ${entityType.toLowerCase()} status. Please try again.`,
      );
    }
  };

  const handleEditEntity = async (entityId, entityType) => {
    setEditMode(true);

    if (entityType === "Consumer") {
      setOpenCon(true);
      setSelectedEntityId(entityId);

      await dispatch(fetchFullConsumerDetails(entityId));
    } else if (entityType === "Generator") {
      setOpenGen(true);
      setSelectedEntityId(entityId);

      await dispatch(fetchFullGeneratorDetails(entityId));
    }
  };

  const handleCloseConsumerModal = () => {
    setOpenCon(false);
    setEditMode(false);
    setSelectedEntityId(null);

    if (companyId) {
      dispatch(fetchConsumersCompanyId(companyId));
    }
  };

  const handleCloseGeneratorModal = () => {
    setOpenGen(false);
    setEditMode(false);
    setSelectedEntityId(null);

    if (companyId) {
      dispatch(fetchGeneratorsCompanyId(companyId));
    }
  };

  const handleViewUsers = (entity, entityType) => {
    // Create entity object compatible with ActionModal
    const entityForAction = {
      ...entity,
      entityType: entityType.toUpperCase(),
      accountType: entityType,
      consumerId: entityType === "Consumer" ? entity.consumerId : undefined,
      generatorId: entityType === "Generator" ? entity.generatorId : undefined,
    };

    setSelectedEntityForAction(entityForAction);
    setOpenAction(true);
  };

  const handleAddUser = (entityType, entityId, entityName) => {
    setUserModalType("add");
    setSelectedUser(null);
    setSelectedEntityForUser({
      entityType,
      entityId,
      entityName,
    });
    setOpenUserModal(true);
  };

  const handleEditUser = (user, entityType, entityId) => {
    setUserModalType("edit");
    setSelectedUser(user);
    setSelectedEntityForUser({
      entityType,
      entityId,
      entityName:
        entityType === "Consumer"
          ? consumers?.find((c) => c.consumerId === entityId)?.consumerName
          : generators?.find((g) => g.generatorId === entityId)?.generatorName,
    });
    setOpenUserModal(true);
  };

  const handleUserAction = async () => {
    const { userId, action } = userConfirmModal;

    try {
      if (action === "toggle") {
        const newStatus = !userConfirmModal.text.includes("deactivate");
        const requesterUserId = "superadmin";

        await changeUserActiveStatusSuperAdmin(
          userId,
          newStatus,
          requesterUserId,
        );
        toast.success(
          `User ${newStatus ? "activated" : "deactivated"} successfully!`,
        );
      }

      setUserConfirmModal({
        status: false,
        heading: "",
        text: "",
        userId: null,
        action: "",
      });
    } catch (error) {
      toast.error("Failed to update user status. Please try again.");
    }
  };

  const handleUserModalClose = () => {
    setOpenUserModal(false);
    setUserModalType("add");
    setSelectedUser(null);
    setSelectedEntityForUser(null);
  };

  const handleUserCreatedOrUpdated = () => {
    if (companyId) {
      dispatch(fetchConsumersCompanyId(companyId));
      dispatch(fetchGeneratorsCompanyId(companyId));
    }
    handleUserModalClose();
  };

  const handleSendNotifyEmail = async ({
    recipientType,
    recipientId,
    emailSubject,
    emailMessage,
  }) => {
    setNotifyEmailLoading(true);
    try {
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yyyy = now.getFullYear();
      const res = await sendStatusChangeNotification({
        companyId: Number(companyId),
        consumerId: recipientType === "CONSUMER" ? Number(recipientId) : null,
        generatorId: recipientType === "GENERATOR" ? Number(recipientId) : null,
        subject: emailSubject,
        message: emailMessage,
        actionDate: `${dd}-${mm}-${yyyy}`,
        reviewerName: "",
        reasons: [],
        note: "",
        ccEmails: [""],
      });
      if (res?.data?.code === 200) {
        SuccessMessage("Email sent successfully");
        setNotifyEmailOpen(false);
      } else {
        ErrorMessage(
          res?.data?.error || res?.data?.message || "Failed to send email",
        );
      }
    } catch {
      ErrorMessage("Failed to send email");
    } finally {
      setNotifyEmailLoading(false);
    }
  };

  const getRoleLabel = () => {
    if (company?.roles?.includes("TRADER")) return "TRADER";
    if (company?.roles?.includes("BANKING")) return "DISCOM";
    if (
      company?.roles?.includes("GENERATOR") &&
      company?.roles?.includes("CONSUMER")
    )
      return "PROSUMER";
    if (company?.roles?.includes("CONSUMER")) return "CONSUMER";
    if (company?.roles?.includes("GENERATOR")) return "GENERATOR";
    return "N/A";
  };

  const statusTagClass =
    {
      VERIFIED: Styles.statusTagVerified,
      UN_VERIFIED: Styles.statusTagUnverified,
      HOLD: Styles.statusTagHold,
      REJECTED: Styles.statusTagRejected,
    }[company?.accountStatus] || Styles.statusTagUnverified;

  return (
    <>
      <PdfPreviewModal />
      <div className={Styles.containerCompanyDetails}>
        {/* ── Breadcrumb bar ── */}
        <div className={Styles.detailBreadcrumbBar}>
          <span className={Styles.bcItem}>Platform</span>
          <span className={Styles.bcSep}>/</span>
          <span className={Styles.bcItem}>Companies</span>
          <span className={Styles.bcSep}>/</span>
          <span className={Styles.bcActive}>
            {company?.companyName || "..."}
          </span>
        </div>

        {/* ── Entity bar ── */}
        <div className={Styles.entityBar}>
          <div className={Styles.entityLeft}>
            <button
              className={Styles.backBtn}
              onClick={() => window.history.back()}
            >
              <ArrowBackIcon style={{ fontSize: "13px" }} />
              Companies
            </button>
            <div className={Styles.barDivider} />
            <div className={Styles.entityBlock}>
              <div className={Styles.entityName}>{company?.companyName}</div>
              <div className={Styles.entityMeta}>
                <span className={Styles.roleTag}>{getRoleLabel()}</span>
                <span className={`${Styles.statusTag} ${statusTagClass}`}>
                  {company?.accountStatus === "VERIFIED" && "✓ "}
                  {company?.accountStatus}
                </span>
              </div>
            </div>
          </div>
          {/* <div
            onClick={() =>
              getCompanyEntityData({ companyId: company?.companyId })
            }
          >
            Excel
          </div> */}
          {userAction && (
            <div className={Styles.actionBtns}>
              {/* <button
                className={`${Styles.btnHold} ${Styles.btnNotify}`}
                onClick={() => setNotifyEmailOpen(true)}
              >
                Notify
              </button>
              <button
                className={Styles.btnHold}
                onClick={() =>
                  company?.accountStatus === "HOLD"
                    ? setConfirmModal({
                        status: true,
                        heading: "Un-Hold",
                        text: "Do you want to activate this company?",
                        type: "VERIFIED",
                      })
                    : setReasonModal({
                        open: true,
                        actionType: "HOLD",
                        type: "HOLD",
                      })
                }
              >
                {company?.accountStatus === "HOLD" ? "UN-HOLD" : "HOLD"}
              </button>
              <button
                className={Styles.btnReject}
                onClick={() =>
                  company?.accountStatus === "REJECTED"
                    ? setConfirmModal({
                        status: true,
                        heading: "Activate",
                        text: "Do you want to activate this company?",
                        type: "VERIFIED",
                      })
                    : setReasonModal({
                        open: true,
                        actionType: "REJECTED",
                        type: "REJECTED",
                      })
                }
              >
                {company?.accountStatus === "REJECTED" ? "ACTIVE" : "REJECT"}
              </button> */}
              {/* <button
                className={Styles.btnVerify}
                onClick={() =>
                  company?.accountStatus === "VERIFIED"
                    ? setReasonModal({
                        open: true,
                        actionType: "UN_VERIFIED",
                        type: "UN_VERIFIED",
                      })
                    : setConfirmModal({
                        status: true,
                        heading: "Verify",
                        text: "Do you want to verify this company?",
                        type: "VERIFIED",
                      })
                }
              >
                {company?.accountStatus === "VERIFIED" ? "UN-VERIFY" : "VERIFY"}
              </button> */}
              {company?.accountStatus !== "VERIFIED" && (
                <button
                  className={Styles.btnVerify}
                  onClick={() =>
                    setConfirmModal({
                      status: true,
                      heading: "Verify",
                      text: "Do you want to verify this company?",
                      type: "VERIFIED",
                    })
                  }
                >
                  VERIFY
                </button>
              )}
            </div>
          )}
        </div>

        {/* ── Inner tabs bar ── */}
        <div className={Styles.innerTabsBar}>
          <div className={Styles.innerTabs}>
            {filteredHeaderList?.map((ele) => (
              <button
                key={ele.value}
                className={`${Styles.innerTab} ${activeView === ele.value ? Styles.innerTabActive : ""}`}
                onClick={() => setActiveView(ele.value)}
              >
                {ele.name}
              </button>
            ))}
          </div>
          <div className={Styles.tabRightActions}>
            {activeView === "Consumer" && userAction && (
              <button
                className={Styles.addEntityBtn}
                onClick={() => setOpenCon(true)}
              >
                + Add Consumer
              </button>
            )}
            {activeView === "Generator" && userAction && (
              <button
                className={Styles.addEntityBtn}
                onClick={() => setOpenGen(true)}
              >
                + Add Generator
              </button>
            )}
          </div>
        </div>

        <div className={`scroll_bar_y ${Styles.detailsSection}`}>
          {activeView === "Company" && <CompanyMainDetails company={company} />}

          {activeView === "Consumer" && (
            <div className={Styles.entityList}>
              <div className={Styles.listHeader}>
                <span className={Styles.listCount}>
                  {consumers?.length || 0} consumers registered
                </span>
              </div>
              {consumers?.map((ele) => {
                const isOpen = activeEntity === ele?.consumerId;
                const initials = (ele?.consumerName || "CO")
                  .substring(0, 2)
                  .toUpperCase();
                const isOn = entityStatus[ele?.consumerId] ?? true;
                return (
                  <div
                    key={ele?.consumerId}
                    className={`${Styles.entityRow} ${isOpen ? Styles.entityRowOpen : ""}`}
                  >
                    <div
                      className={Styles.entityRowHeader}
                      onClick={() => handleEntity(ele?.consumerId, "Consumer")}
                    >
                      <div className={Styles.entityRowLeft}>
                        <div className={Styles.entityRowAvatar}>{initials}</div>
                        <div>
                          <div className={Styles.entityRowName}>
                            {ele?.consumerName}
                          </div>
                          <div className={Styles.entityRowId}>
                            {ele?.uniqueId}
                          </div>
                        </div>
                      </div>
                      <div
                        className={Styles.entityRowRight}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {userAction && (
                          <button
                            className={Styles.iconBtn}
                            title="View Users"
                            onClick={() => handleViewUsers(ele, "Consumer")}
                          >
                            <RemoveRedEyeIcon style={{ fontSize: "13px" }} />
                          </button>
                        )}
                        {userAction && (
                          <button
                            className={Styles.iconBtn}
                            title="Edit"
                            onClick={() =>
                              handleEditEntity(ele?.consumerId, "Consumer")
                            }
                          >
                            <BorderColorIcon style={{ fontSize: "13px" }} />
                          </button>
                        )}
                        {userAction && (
                          <label className={Styles.toggleSwitch}>
                            <input
                              type="checkbox"
                              checked={isOn}
                              onChange={() =>
                                handleToggleEntity(ele?.consumerId, "Consumer")
                              }
                            />
                            <span
                              className={`${Styles.toggleSlider} ${isOn ? Styles.toggleOn : ""}`}
                            />
                          </label>
                        )}
                        <span
                          className={`${Styles.chevronIcon} ${isOpen ? Styles.chevronOpen : ""}`}
                        >
                          ▾
                        </span>
                      </div>
                    </div>
                    {isOpen && (
                      <div className={Styles.entityRowContent}>
                        <ConsumerDetails
                          fullConsumerDetails={fullConsumerDetails}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {activeView === "Generator" && (
            <div className={Styles.entityList}>
              <div className={Styles.listHeader}>
                <span className={Styles.listCount}>
                  {generators?.length || 0} generators registered
                </span>
              </div>
              {generators?.map((ele) => {
                const isOpen = activeEntity === ele?.generatorId;
                const initials = (ele?.generatorName || "GE")
                  .substring(0, 2)
                  .toUpperCase();
                const isOn = entityStatus[ele?.generatorId] ?? true;
                return (
                  <div
                    key={ele?.generatorId}
                    className={`${Styles.entityRow} ${isOpen ? Styles.entityRowOpen : ""}`}
                  >
                    <div
                      className={Styles.entityRowHeader}
                      onClick={() =>
                        handleEntity(ele?.generatorId, "Generator")
                      }
                    >
                      <div className={Styles.entityRowLeft}>
                        <div className={Styles.entityRowAvatar}>{initials}</div>
                        <div>
                          <div className={Styles.entityRowName}>
                            {ele?.generatorName}
                          </div>
                          <div className={Styles.entityRowId}>
                            {ele?.uniqueId}
                          </div>
                        </div>
                      </div>
                      <div
                        className={Styles.entityRowRight}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {userAction && (
                          <button
                            className={Styles.iconBtn}
                            title="View Users"
                            onClick={() => handleViewUsers(ele, "Generator")}
                          >
                            <RemoveRedEyeIcon style={{ fontSize: "13px" }} />
                          </button>
                        )}
                        {userAction && (
                          <button
                            className={Styles.iconBtn}
                            title="Edit"
                            onClick={() =>
                              handleEditEntity(ele?.generatorId, "Generator")
                            }
                          >
                            <BorderColorIcon style={{ fontSize: "13px" }} />
                          </button>
                        )}
                        {userAction && (
                          <label className={Styles.toggleSwitch}>
                            <input
                              type="checkbox"
                              checked={isOn}
                              onChange={() =>
                                handleToggleEntity(
                                  ele?.generatorId,
                                  "Generator",
                                )
                              }
                            />
                            <span
                              className={`${Styles.toggleSlider} ${isOn ? Styles.toggleOn : ""}`}
                            />
                          </label>
                        )}
                        <span
                          className={`${Styles.chevronIcon} ${isOpen ? Styles.chevronOpen : ""}`}
                        >
                          ▾
                        </span>
                      </div>
                    </div>
                    {isOpen && (
                      <div className={Styles.entityRowContent}>
                        <GeneratorDetails
                          fullGeneratorDetails={fullGeneratorDetails}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {activeView === "Discom" && (
            <div className={Styles.entityList}>
              {discoms && discoms.length > 0 ? (
                discoms.map((ele, index) => {
                  const isOpen = activeEntity === ele?.discomId;
                  const initials = (ele?.acronym || "DC")
                    .substring(0, 2)
                    .toUpperCase();
                  return (
                    <div
                      key={index}
                      className={`${Styles.entityRow} ${isOpen ? Styles.entityRowOpen : ""}`}
                    >
                      <div
                        className={Styles.entityRowHeader}
                        onClick={() => handleEntity(ele?.discomId, "Discom")}
                      >
                        <div className={Styles.entityRowLeft}>
                          <div className={Styles.entityRowAvatar}>
                            {initials}
                          </div>
                          <div>
                            <div className={Styles.entityRowName}>
                              {ele?.acronym}
                            </div>
                            <div className={Styles.entityRowId}>
                              Discom entity · Created{" "}
                              {ele?.createdAt?.split("T")[0]}
                            </div>
                          </div>
                        </div>
                        <div
                          className={Styles.entityRowRight}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {userAction && (
                            <button className={Styles.iconBtn} title="View">
                              <RemoveRedEyeIcon style={{ fontSize: "13px" }} />
                            </button>
                          )}
                          {userAction && (
                            <button className={Styles.iconBtn} title="Edit">
                              <BorderColorIcon style={{ fontSize: "13px" }} />
                            </button>
                          )}
                          <span
                            className={`${Styles.chevronIcon} ${isOpen ? Styles.chevronOpen : ""}`}
                          >
                            ▾
                          </span>
                        </div>
                      </div>
                      {isOpen && (
                        <div className={Styles.entityRowContent}>
                          <DiscomDetails discom={ele} />
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div className={Styles.emptyState}>
                  No Discom Details Available
                </div>
              )}
            </div>
          )}

          {activeView === "Documents" && (
            <DocumentDetails
              company={company}
              handlePreviewGeneralTerms={handlePreviewGeneralTerms}
              companyId={companyId}
              userAction={userAction}
            />
          )}
          {activeView === "Configuration" && (
            <ConfigurationDetails
              companyId={companyId}
              traders={traders}
              isTraderOnly={company?.roles?.includes("TRADER")}
            />
          )}
        </div>
      </div>

      {/* Modals placed at the end to ensure proper layering */}
      <NotifyEmailModal
        open={notifyEmailOpen}
        onClose={() => setNotifyEmailOpen(false)}
        onSend={handleSendNotifyEmail}
        companyName={company?.companyName}
        loading={notifyEmailLoading}
        recipients={[
          {
            type: "COMPANY",
            id: companyId,
            label: company?.companyName || "Company",
            group: "Company",
          },
          ...(consumers?.map((c) => ({
            type: "CONSUMER",
            id: c.consumerId,
            label: c.consumerName,
            group: "Consumers",
          })) || []),
          ...(generators?.map((g) => ({
            type: "GENERATOR",
            id: g.generatorId,
            label: g.generatorName,
            group: "Generators",
          })) || []),
          ...(discoms?.map((d) => ({
            type: "DISCOM",
            id: d.discomId,
            label: d.discomName || d.acronym,
            group: "Discoms",
          })) || []),
        ]}
      />

      <ReasonModal
        open={reasonModal.open}
        onClose={() =>
          setReasonModal({ open: false, actionType: "", type: "" })
        }
        actionType={reasonModal.actionType}
        onConfirm={handleUpdateStatus}
        companyName={company?.companyName}
      />

      {confirmModal?.status && (
        <ConfirmationModal
          open={confirmModal?.status}
          handleClose={() =>
            setConfirmModal({
              status: false,
              heading: "",
              text: "",
              type: "",
            })
          }
          header={confirmModal?.header}
          data={confirmModal?.text}
          handleSubmit={handleUpdateStatus}
        />
      )}
      {toggleConfirmModal?.status && (
        <ConfirmationModal
          open={toggleConfirmModal?.status}
          handleClose={() =>
            setToggleConfirmModal({
              status: false,
              heading: "",
              text: "",
              entityType: "",
              entityId: null,
            })
          }
          header={toggleConfirmModal?.heading}
          data={toggleConfirmModal?.text}
          handleSubmit={handleConfirmToggle}
        />
      )}
      {openCon && (
        <Modal
          open={openCon}
          onClose={handleCloseConsumerModal}
          aria-labelledby="add-consumer-modal"
          aria-describedby="add-consumer-form"
        >
          <div
            className="popupModal"
            style={{
              width: "90%",
              maxWidth: "1200px",
              height: "85%",
              maxHeight: "750px",
              overflow: "hidden",
              padding: 0,
            }}
          >
            <CompanyAdminConsumerForm
              handleClose={handleCloseConsumerModal}
              isModal={true}
              isSuperAdmin={true}
              editMode={editMode}
              entityId={selectedEntityId}
              companyId={companyId}
              entityData={fullConsumerDetails}
              hideSelection={true}
            />
          </div>
        </Modal>
      )}
      {openGen && (
        <Modal
          open={openGen}
          onClose={handleCloseGeneratorModal}
          aria-labelledby="add-generator-modal"
          aria-describedby="add-generator-form"
        >
          <div
            className="popupModal"
            style={{
              width: "90%",
              maxWidth: "1200px",
              height: "85%",
              maxHeight: "750px",
              overflow: "hidden",
              padding: 0,
            }}
          >
            <CompanyAdminGeneratorForm
              handleClose={handleCloseGeneratorModal}
              isModal={true}
              isSuperAdmin={true}
              editMode={editMode}
              entityId={selectedEntityId}
              companyId={companyId}
              entityData={fullGeneratorDetails}
              hideSelection={true}
            />
          </div>
        </Modal>
      )}

      {/* Add User Modal */}
      {openUserModal && (
        <AddUserModal
          open={openUserModal}
          handleClose={handleUserModalClose}
          header={userModalType === "add" ? "Add User" : "Edit User"}
          userToEdit={selectedUser}
          entityId={selectedEntityForUser?.entityId}
          entityType={selectedEntityForUser?.entityType}
          onUserUpdated={handleUserCreatedOrUpdated}
          entities={
            selectedEntityForUser
              ? [
                  {
                    id: `${selectedEntityForUser.entityType.toLowerCase()}-${
                      selectedEntityForUser.entityId
                    }`,
                    name: selectedEntityForUser.entityName,
                    value: `${selectedEntityForUser.entityType}-${selectedEntityForUser.entityId}`,
                    entityId: selectedEntityForUser.entityId,
                    entityType: selectedEntityForUser.entityType,
                    entityName: selectedEntityForUser.entityName,
                  },
                ]
              : activeView === "Consumer"
                ? consumers?.map((consumer, index) => ({
                    id: `consumer-${consumer.consumerId || index}`,
                    name: consumer.consumerName || `Consumer ${index + 1}`,
                    value: `CONSUMER-${consumer.consumerId}`,
                    entityId: consumer.consumerId,
                    entityType: "CONSUMER",
                    entityName: consumer.consumerName,
                  }))
                : activeView === "Generator"
                  ? generators?.map((generator, index) => ({
                      id: `generator-${generator.generatorId || index}`,
                      name: generator.generatorName || `Generator ${index + 1}`,
                      value: `GENERATOR-${generator.generatorId}`,
                      entityId: generator.generatorId,
                      entityType: "GENERATOR",
                      entityName: generator.generatorName,
                    }))
                  : []
          }
          isInAction={userModalType === "edit"}
          addUser={addUserSuperAdmin}
          updateUser={updateUserSuperAdmin}
          isSuperAdmin={true}
          // isTraderCompany={company?.roles?.includes("TRADER")}
        />
      )}

      {/* Action Modal for viewing users */}
      {openAction && selectedEntityForAction && (
        <ActionModal
          open={openAction}
          handleClose={() => {
            setOpenAction(false);
            setSelectedEntityForAction(null);
          }}
          selectedEntity={selectedEntityForAction}
          isSuperAdmin={true}
        />
      )}

      {/* User Action Confirmation Modal */}
      {userConfirmModal.status && (
        <ConfirmationModal
          open={userConfirmModal.status}
          handleClose={() =>
            setUserConfirmModal({
              status: false,
              heading: "",
              text: "",
              userId: null,
              action: "",
            })
          }
          header={userConfirmModal.heading}
          data={userConfirmModal.text}
          handleSubmit={handleUserAction}
        />
      )}
    </>
  );
};

export default CompanyDetails;
